(()=>{
'use strict';
let connected=false, attempts=0;
function attach(){
 const host=document.getElementById('smart-bot-container');
 const root=host&&host.shadowRoot;
 if(!root||connected)return;
 connected=true;
 const style=document.createElement('style');
 style.textContent='[data-splus-chat-dir]{direction:var(--splus-chat-direction)!important;text-align:start!important;unicode-bidi:plaintext!important} [data-splus-chat-dir] p,[data-splus-chat-dir] li{direction:inherit!important;text-align:start!important;unicode-bidi:plaintext} [data-splus-chat-dir] a{unicode-bidi:isolate}';
 root.append(style);
 const selector='[class*="_bubble-text_"],[class*="_bubble-faq-item_"],[class*="_operator-name_"],textarea,[contenteditable="true"]';
 function update(){
  root.querySelectorAll(selector).forEach(el=>{
   const text=el.matches('textarea')?el.value:el.textContent;
   const ar=/[\u0600-\u06ff\u0750-\u077f\u08a0-\u08ff]/.test(text||'');
   const dir=ar?'rtl':(text&&text.trim()?'ltr':(document.documentElement.lang.startsWith('ar')?'rtl':'ltr'));
   if(el.getAttribute('data-splus-chat-dir')!==dir){
    el.setAttribute('data-splus-chat-dir',dir);el.setAttribute('dir',dir);
    el.style.setProperty('--splus-chat-direction',dir);
   }
  });
 }
 let queued=false;
 new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;update();});}}).observe(root,{childList:true,subtree:true,characterData:true});
 root.addEventListener('input',update);
 update();
}
const timer=setInterval(()=>{attach();if(connected||++attempts>=120)clearInterval(timer);},500);
document.addEventListener('click',attach,{passive:true});
attach();
})();